export class WorkloadManagerCardEntity {
  public userId!: string;
  public firstName!: string;
  public lastName!: string;
  public email!: string;
  public teamIds!: string[];
  public teamCount!: number;
  public totalMembers!: number;
  public overCapacityCount!: number;
  public overdueCount!: number;
  public atRiskCount!: number;
}

export class WorkloadDirectorRollupEntity {
  public managers!: WorkloadManagerCardEntity[];
}
